import { FETCH_USER_GROUP_PRICING, DELETE_USER_GROUP_PRICING, UPDATE_USER_GROUP_PRICING, CREATE_USER_GROUP_PRICING, GET_USER_GROUP_PRICING } from 'actions/userGroupPricing';
import { toast } from 'react-toastify';
import _ from 'lodash';

const initialState = {
  isLoading: false,
  userGroupPricing: [],
  userGroupPricingDetail: {},
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const userGroupPricingReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case UPDATE_USER_GROUP_PRICING.REQUEST:
    case DELETE_USER_GROUP_PRICING.REQUEST:
    case FETCH_USER_GROUP_PRICING.REQUEST:
    case CREATE_USER_GROUP_PRICING.REQUEST:
    case GET_USER_GROUP_PRICING.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_USER_GROUP_PRICING.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        userGroupPricing: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case GET_USER_GROUP_PRICING.SUCCESS: {
      return {
        ...state,
        userGroupPricingDetail: payload,
        isLoading: false,
      };
    }

    case CREATE_USER_GROUP_PRICING.SUCCESS: {
      toast.success('User Group Pricing added successfully');
      return {
        ...state,
        userGroupPricing: _.concat(state.userGroupPricing, payload),
        isLoading: false,
      };
    }

    case UPDATE_USER_GROUP_PRICING.SUCCESS: {
      toast.success('User Group Pricing updated successfully');
      return {
        ...state,
        isLoading: false,
        userGroupPricing: state.userGroupPricing.map((data) => (data.id === payload.id ? payload : data)),
      };
    }

    case DELETE_USER_GROUP_PRICING.SUCCESS: {
      toast.success('User Group Pricing deleted successfully');
      return {
        ...state,
        userGroupPricing: state.userGroupPricing.filter((data) => data.id !== payload),
      };
    }
    case DELETE_USER_GROUP_PRICING.FAIL:
    case UPDATE_USER_GROUP_PRICING.FAIL:
    case FETCH_USER_GROUP_PRICING.FAIL:
    case CREATE_USER_GROUP_PRICING.FAIL:
    case GET_USER_GROUP_PRICING.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default userGroupPricingReducer;
